import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api, { apiError, fmtMoney, fmtDate } from "@/lib/api";
import { PageHeader } from "@/components/shared/PageHeader";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

const STAGES = ["Nouvelle", "Confirmée", "En préparation", "Expédiée", "Livrée", "Annulée"];
const COLOR = { "Nouvelle": "text-blue-400", "Confirmée": "text-emerald-400", "En préparation": "text-amber-400", "Expédiée": "text-purple-400", "Livrée": "text-emerald-400", "Annulée": "text-red-400" };

export default function StoreOrders() {
  const { slug } = useParams();
  const [rows, setRows] = useState(null);
  const load = () => api.get(`/store/${slug}/orders`).then((r) => setRows(r.data)).catch(() => setRows([]));
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [slug]);

  const change = async (o, status) => {
    setRows((r) => r.map((x) => (x.id === o.id ? { ...x, status } : x)));
    try { await api.patch(`/store/${slug}/orders/${o.id}/status`, { status }); toast.success("Statut mis à jour"); }
    catch (e) { toast.error(apiError(e)); load(); }
  };

  return (
    <div>
      <PageHeader title="Commandes en ligne" subtitle="Commandes reçues depuis la boutique en ligne" />
      <div className="vp-card rounded-xl overflow-hidden">
        <div className="overflow-x-auto">
          <Table>
            <TableHeader><TableRow className="border-white/10 hover:bg-transparent">
              {["N°", "Client", "Articles", "Montant", "Paiement", "Date", "Statut"].map((h) => <TableHead key={h} className="text-slate-400 text-xs uppercase tracking-wider">{h}</TableHead>)}
            </TableRow></TableHeader>
            <TableBody>
              {rows === null && <TableRow><TableCell colSpan={7} className="text-center py-10 text-slate-500"><Loader2 className="animate-spin inline mr-2" size={16} /> Chargement…</TableCell></TableRow>}
              {rows && rows.map((o) => (
                <TableRow key={o.id} className="border-white/5 hover:bg-white/[0.03]" data-testid="order-row">
                  <TableCell className="mono text-sm text-white">{o.number}</TableCell>
                  <TableCell className="text-slate-300 text-sm">{o.customer_name}<div className="text-xs text-slate-500">{o.customer_phone}</div></TableCell>
                  <TableCell className="mono text-sm text-slate-400">{o.items?.reduce((a, i) => a + i.qty, 0)}</TableCell>
                  <TableCell className="mono text-sm text-white">{fmtMoney(o.total)}</TableCell>
                  <TableCell className="text-slate-400 text-sm">{o.payment_method}</TableCell>
                  <TableCell className="text-slate-400 text-sm">{fmtDate(o.created_at)}</TableCell>
                  <TableCell>
                    <Select value={o.status} onValueChange={(v) => change(o, v)}>
                      <SelectTrigger className={`bg-black/30 border-white/10 h-8 text-xs w-36 ${COLOR[o.status] || "text-slate-300"}`} data-testid="order-status-select"><SelectValue /></SelectTrigger>
                      <SelectContent className="vp-card border-white/10 text-white">{STAGES.map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}</SelectContent>
                    </Select>
                  </TableCell>
                </TableRow>
              ))}
              {rows && rows.length === 0 && <TableRow><TableCell colSpan={7} className="text-center py-10 text-slate-500">Aucune commande</TableCell></TableRow>}
            </TableBody>
          </Table>
        </div>
      </div>
    </div>
  );
}
